import React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import Header from "@/components/ui/header";
import Breadcrumb from "@/components/ui/breadcrumb";
import styles from "./ReportDetailLayout.module.scss";

interface ReportDetailLayoutProps {
  title: string;
  description?: string;
  categoryLabel?: string;
  exportSlot?: React.ReactNode;
  filterSlot?: React.ReactNode;
  children: React.ReactNode;
}

const ReportDetailLayout: React.FC<ReportDetailLayoutProps> = ({
  title,
  description,
  categoryLabel,
  exportSlot,
  filterSlot,
  children,
}) => {
  const navigate = useNavigate();

  const items = [
    {
      label: "Raporlar",
      onClick: () => navigate("/dashboard/reports"),
    },
    ...(categoryLabel ? [{ label: categoryLabel }] : []),
    { label: title },
  ];

  return (
    <DashboardLayout>
      <Header title={title} />
      <div className={styles.topBar}>
        <Breadcrumb items={items} />
        {exportSlot && <div className={styles.exportSlot}>{exportSlot}</div>}
      </div>
      <div className={styles.titleRow}>
        <div className={styles.titleBlock}>
          <h2 className={styles.title}>{title}</h2>
          {description && <p className={styles.description}>{description}</p>}
        </div>
      </div>
      {filterSlot && <div className={styles.filterSlot}>{filterSlot}</div>}
      <div className={styles.content}>{children}</div>
    </DashboardLayout>
  );
};

export default ReportDetailLayout;
